import type { ConcursCard } from "../types";

/**
 * As quatro peças do concurs de relats "Blau de vidre", na ordem em que se
 * montam no mosaico final: convocatòria, bases, calendari i premis.
 */
export const concursCards: ConcursCard[] = [
	{
		id: "concurs-blau-de-vidre",
		kicker: "I concurs de relats",
		title: "Blau de vidre",
		description:
			"Cosa Nova 17488 convoca el seu primer certamen literari per reivindicar el conte i fomentar la creació en llengua catalana.",
		image: "/assets/blau-de-vidre-1.jpg",
		color: "#faf5eb",
	},
	{
		id: "concurs-bases",
		kicker: "bases",
		title: "Tema i qui hi pot participar?",
		description:
			"Tema: ARRELS, d’interpretació lliure. Hi poden participar majors de 16 anys amb relats inèdits en català, d’entre 3 i 5 pàgines (Arial 12, doble espai). S’accepta un màxim de 2 obres per participant. No s’acceptaran textos generats amb IA.",
		image: "/assets/blau-de-vidre-2.jpg",
		color: "#253a64",
	},
	{
		id: "concurs-termini",
		kicker: "calendari",
		title: "Termini de presentació",
		description:
			"Del 21 de juny (09.24 h) al 21 de desembre (21.49 h), de solstici a solstici. Envia la teva obra a info@cosanova.cat: el relat en PDF i de forma anònima, i un document separat (plica) amb les dades de contacte. Cal fer ús d’un llenguatge inclusiu i no sexista.",
		image: "/assets/blau-de-vidre-3.jpg",
		color: "#253a64",
	},
	{
		id: "concurs-premis",
		kicker: "premis",
		title: "Escultura i premis en metàl·lic",
		description:
			"1r premi: escultura, 1.000 € i 10 exemplars. 2n premi: 600 € i 6 exemplars. 3r premi: 400 € i 4 exemplars. Les obres guanyadores i una selecció de les millors es publicaran en un volum col·lectiu. L’entrega de premis tindrà lloc al Primer Festival Literari Internacional de Cadaqués, el març de 2027.",
		image: "/assets/blau-de-vidre-4.jpg",
		color: "#253a64",
	},
];
